import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { EasyPost_ModuleContextService } from './EasyPost.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class EasyPost_easypost_tester_form_ComponentContextService {
  private readonly moduleContext: EasyPost_ModuleContextService;

  constructor(moduleContext: EasyPost_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'easypost_tester_form',
      type: ComponentType.form
    }
  }
}